module.exports = __webpack_public_path__ + "img/filedrop.0bb5e7c6.svg";